// extracted by mini-css-extract-plugin
export default {"withDividers":"classes_withDividers__UrHEu","divider":"classes_divider__y8p9t"};